// src/contexts/PathContext.js
import React, { createContext, useState } from 'react';

export const PathContext = createContext({
  path: '',
  setPath: () => {}
});

export function PathProvider({ children }) {
  const [path, setPath] = useState('');
  return (
    <PathContext.Provider value={{ path, setPath }}>
      {children}
    </PathContext.Provider>
  );
}
